function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4A90E2",
  fillRule: "nonzero",
  d: "M3.75 0A2.258 2.258 0 0 0 1.5 2.25 2.258 2.258 0 0 0 3.75 4.5 2.258 2.258 0 0 0 6 2.25 2.258 2.258 0 0 0 3.75 0zm0 4.5h-1.5A2.258 2.258 0 0 0 0 6.75v4.81l1.5 1.5V18H6v-7.5H4.5v6H3v-4.06l-1.5-1.5V6.75A.74.74 0 0 1 2.25 6h3c.229 0 .814.27 1.4.633.586.369 1.108.867 1.975.867H12V6H8.625c.041 0-.568-.252-1.178-.633-.61-.387-1.3-.867-2.197-.867h-1.5zm0-3a.74.74 0 0 1 .75.75.74.74 0 0 1-.75.75.74.74 0 0 1-.75-.75.74.74 0 0 1 .75-.75zm4.5 0a.748.748 0 0 0-.75.75v1.412c.31.17.61.346.879.522.123.07.363.222.527.316H9V3h10.5v7.5H9V9H7.5v2.25c0 .416.334.75.75.75h3.563l-3.065 4.5h1.81l3.065-4.5h1.254l3.059 4.5h1.816L16.688 12h3.562c.416 0 .75-.334.75-.75v-9a.748.748 0 0 0-.75-.75h-12z"
});

var SvgPresentation = function SvgPresentation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPresentation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/presentation.38c034e1.svg";
export { ForwardRef as ReactComponent };